import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  // Ambil data dari localStorage secara teliti
  const token = localStorage.getItem("eventManagementAuthToken");
  const role = localStorage.getItem("eventManagementUserRole");

  // 1. Jika tidak ada token (belum login), lempar ke halaman login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // 2. Jika bukan Admin atau Helper, lempar balik ke Landing Page
  if (role !== "Admin" && role !== "Helper") {
    return <Navigate to="/" replace />;
  }

  // Jika lolos verifikasi, tampilkan halaman anak (Admin Index) melalui <Outlet />
  return <Outlet />; 
};

export default ProtectedRoute;